export default "__VITE_ASSET__BApBDORK__"